import {GlobalContext} from '@acng/frontend-relativity';

/**
 * Observe the availability of pins.
 */
const observable = GlobalContext(true);

export {observable as ctxPinsAvailable};
